import React from "react";

export default function Icon({
  children,
  name,
  size = 20,
  color = false,
  marginTop = false,
  ...props
}) {
  return (
    <>
      <i
        className={`material-icons`}
        style={{ fontSize: size, color: color, marginTop: marginTop }}
        aria-hidden="true"
        {...props}
      >
        {name}
      </i>
      {children}
    </>
  );
}
